import { Box, Typography } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { useLogout } from 'hooks/useLogout';

import { LogoutIcon } from 'svg/LogoutIcon';

import { logooutContainerSx } from './styles';

// Кнопка разлогина в сайдбаре
/**
 *
 */
export const LogoutButton: FC = () => {
  const { t } = useTranslation();
  const logout = useLogout();

  /**
   *
   */
  const renderContent = () => (
    <Box sx={logooutContainerSx} onClick={logout}>
      <LogoutIcon />
      <Typography marginLeft={1} color='secondary' fontSize='.75rem'>
        { t('user.logout') }
      </Typography>
    </Box>
  );

  return renderContent();
};
